import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterStatus } from '@/api/model/interfaces';

export default class RegisterStatusOdata extends OdataManager<RegisterStatus> {}
